app.controller('outboundTrxCtrl', function ($rootScope, $scope, $state, $filter, $stateParams, shareData, uuid, urlServices, toaster, modalFactory, modalService) {
    var lastLookupAwb = null;
    var shipmentChargeLookupTimer = null;
    var currentPathName = String((window && window.location && window.location.pathname) || '').replace(/\/+$/, '').toLowerCase();

    if ($rootScope.globalFormatDateRangePickerSingleTimeOption && $rootScope.globalFormatDateRangePickerSingleTimeOption.minDate) {
        delete $rootScope.globalFormatDateRangePickerSingleTimeOption.minData;
    }

    $scope.isEWaybillMode = currentPathName === '/e-waybill-entry';
    $scope.isReadOnly = false;
    $scope.isEdit = false;
    $scope.isAutoNumber = false;
    $scope.loadingData = false;
    $scope.saving = false;
    $scope.checkingAwb = false;
    $scope.deleteAuthorized = false;
    $scope.isWeightMetricManual = false;
    $scope.isChargeShipmentManual = false;
    $scope.suspendShipmentChargeLookup = false;
    $scope.originalAwb = null;
    $scope.currentAwbStatus = null;
    $scope.dataOutbound = {};
    $scope.detailItem = [];
    $scope.volumeRows = [];
    $scope.showItemsSection = false;
    $scope.paymentOptions = [
        { PaymentName: 'CASH' },
        { PaymentName: 'CREDIT' }
    ];
    $scope.collectOptions = [
        { value: 'CASH', label: 'CASH' },
        { value: 'COLLECT', label: 'COLLECT' }
    ];

    function createEmptyItem(sn) {
        return {
            item_code: '',
            desc: '',
            sn: String(sn || ''),
            qty: null,
            uom: $scope.dataOutbound.uom || '',
            qty_box: null,
            weight: null,
            notes: ''
        };
    }

    function normalizeAwbValue(value) {
        return String(value || '').trim().toUpperCase();
    }

    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    function normalizeEnumValue(value, fallback) {
        var normalized = normalizeTextValue(value).toUpperCase();

        if (!normalized && fallback !== undefined) {
            return normalizeEnumValue(fallback);
        }
        return normalized;
    }

    function derivePaymentType(typeValue) {
        var normalizedType = normalizeEnumValue(typeValue);

        if (normalizedType.indexOf('CASH') >= 0) {
            return 'CASH';
        }
        return 'CREDIT';
    }

    function deriveOutboundType(paymentValue, currentType) {
        var normalizedType = normalizeTextValue(currentType);
        var normalizedPayment;

        if (normalizedType) {
            return normalizedType;
        }

        normalizedPayment = normalizeEnumValue(paymentValue, 'CREDIT');
        return normalizedPayment === 'CASH' ? 'CASH SALES' : 'CREDIT SALES';
    }

    function canonicalizeOptionValue(value) {
        return normalizeEnumValue(value).replace(/\s+/g, ' ');
    }

    function normalizeNumberValue(value) {
        var parsed = Number(value);
        return isNaN(parsed) ? 0 : parsed;
    }

    function roundCurrencyValue(value) {
        return Math.round(normalizeNumberValue(value));
    }

    function roundMetricValue(value) {
        return Number(normalizeNumberValue(value).toFixed(2));
    }

    function getVolumeDivider(modtrans) {
        var mode = String(modtrans || '').toUpperCase();

        if (mode === 'LAND') {
            return 4000;
        }
        if (mode === 'SEA') {
            return 10000;
        }
        return 6000;
    }

    function calculateWeightMetric(row) {
        var pValue = normalizeNumberValue(row.p);
        var lValue = normalizeNumberValue(row.l);
        var tValue = normalizeNumberValue(row.t);
        var divider = getVolumeDivider($scope.dataOutbound.modtrans);

        if (!pValue || !lValue || !tValue || !divider) {
            return 0;
        }
        return roundMetricValue((pValue * lValue * tValue) / divider);
    }

    function normalizeDetailItem(item, index) {
        return {
            item_code: item.ItemCode || item.item_code || '',
            desc: item.Description || item.desc || '',
            sn: String(item.SN || item.sn || (index + 1)),
            qty: normalizeNumberValue(item.Qty || item.qty),
            uom: item.UOM || item.uom || $scope.dataOutbound.uom || '',
            qty_box: normalizeNumberValue(item.QtyBox || item.qty_box),
            weight: normalizeNumberValue(item.Weight || item.weight),
            notes: item.Notes || item.notes || ''
        };
    }

    function normalizeVolumeRow(row, index) {
        var normalized = {
            awb: normalizeAwbValue(row.AWB || row.awb || $scope.dataOutbound.awb),
            p: normalizeNumberValue(row.P || row.p),
            l: normalizeNumberValue(row.L || row.l),
            t: normalizeNumberValue(row.T || row.t),
            weightMetric: normalizeNumberValue(row.Weight_Metric || row.weight_metric || row.weightMetric),
            noOfCollie: normalizeNumberValue(row.NoOfCollie || row.no_of_collie || row.noOfCollie || (index + 1)),
            collie: normalizeNumberValue(row.Collie || row.collie || $scope.dataOutbound.collie)
        };

        if (!normalized.weightMetric && (normalized.p || normalized.l || normalized.t)) {
            normalized.weightMetric = calculateWeightMetric(normalized);
        }

        return normalized;
    }

    function resequenceDetailItems() {
        $scope.detailItem = ($scope.detailItem || []).map(function (item, index) {
            var normalized = normalizeDetailItem(item, index);

            if (!normalized.sn) {
                normalized.sn = String(index + 1);
            }
            return normalized;
        });
    }

    function recalculateVolumeTotals(options) {
        var totalWeightMetric = 0;
        var totalCollie = normalizeNumberValue($scope.dataOutbound.collie);
        var preserveManual = options && options.preserveManual && $scope.isWeightMetricManual;

        $scope.volumeRows = ($scope.volumeRows || []).map(function (row, index) {
            var normalized = normalizeVolumeRow(row, index);

            normalized.awb = normalizeAwbValue($scope.dataOutbound.awb) || normalized.awb;
            normalized.noOfCollie = normalized.noOfCollie || (index + 1);
            normalized.collie = totalCollie || normalized.collie || $scope.volumeRows.length;
            totalWeightMetric += normalizeNumberValue(normalized.weightMetric);
            return normalized;
        });

        if (!preserveManual) {
            $scope.dataOutbound.weight_metrik = roundMetricValue(totalWeightMetric);
        }
    }

    function buildDefaultVolumeRow(index, rowCount) {
        var totalWeightMetric = normalizeNumberValue($scope.dataOutbound.weight_metrik);
        var row = {
            awb: normalizeAwbValue($scope.dataOutbound.awb),
            p: normalizeNumberValue($scope.dataOutbound.l),
            l: normalizeNumberValue($scope.dataOutbound.w),
            t: normalizeNumberValue($scope.dataOutbound.h),
            weightMetric: rowCount > 0 ? roundMetricValue(totalWeightMetric / rowCount) : 0,
            noOfCollie: index + 1,
            collie: normalizeNumberValue($scope.dataOutbound.collie) || rowCount
        };

        if (!row.weightMetric) {
            row.weightMetric = calculateWeightMetric(row);
        }

        return row;
    }

    function refreshVolumeRows(rowsOverride, options) {
        var totalCollie = normalizeNumberValue($scope.dataOutbound.collie);
        var rowCount = totalCollie > 0 ? totalCollie : 1;
        var sourceRows = angular.isArray(rowsOverride) ? rowsOverride : $scope.volumeRows;
        var rows = [];
        var index;

        if (options && options.resetManual) {
            $scope.isWeightMetricManual = false;
        }

        for (index = 0; index < rowCount; index += 1) {
            if (sourceRows && sourceRows[index]) {
                rows.push(normalizeVolumeRow(sourceRows[index], index));
            } else {
                rows.push(buildDefaultVolumeRow(index, rowCount));
            }
        }

        $scope.volumeRows = rows;
        recalculateVolumeTotals(options);
    }

    function getOptionValue(option, keys) {
        var index;

        if (!option) {
            return '';
        }
        if (!angular.isArray(keys) || keys.length === 0) {
            return normalizeTextValue(option);
        }
        for (index = 0; index < keys.length; index += 1) {
            if (option[keys[index]] !== undefined && option[keys[index]] !== null && option[keys[index]] !== '') {
                return normalizeTextValue(option[keys[index]]);
            }
        }
        return '';
    }

    function getFirstOptionValue(options, keys) {
        if (!angular.isArray(options) || options.length === 0) {
            return '';
        }
        return getOptionValue(options[0], keys);
    }

    function findMatchingOptionValue(currentValue, options, keys) {
        var normalizedCurrent = canonicalizeOptionValue(currentValue);
        var index;
        var optionValue;

        if (!normalizedCurrent || !angular.isArray(options)) {
            return '';
        }
        for (index = 0; index < options.length; index += 1) {
            optionValue = getOptionValue(options[index], keys);
            if (canonicalizeOptionValue(optionValue) === normalizedCurrent) {
                return optionValue;
            }
        }
        return '';
    }

    function reconcileOutboundSelections() {
        var distServices = ($scope.defaultData && $scope.defaultData.distServices) || [];
        var uomList = ($scope.defaultData && $scope.defaultData.uom) || [];
        var packingList = ($scope.defaultData && $scope.defaultData.packing) || [];
        var paymentList = ($scope.defaultData && $scope.defaultData.paymentTypes) || $scope.paymentOptions;
        var serviceValue = findMatchingOptionValue($scope.dataOutbound.service, distServices, ['ServiceCode']);
        var uomValue = findMatchingOptionValue($scope.dataOutbound.uom, uomList, ['UOMCode']);
        var packingValue = findMatchingOptionValue($scope.dataOutbound.packing, packingList, ['PackingName']);
        var paymentValue = findMatchingOptionValue($scope.dataOutbound.payment_type, paymentList, ['PaymentName']);

        $scope.dataOutbound.modtrans = normalizeEnumValue($scope.dataOutbound.modtrans, 'AIR');
        $scope.dataOutbound.paket = normalizeEnumValue($scope.dataOutbound.paket, 'P');
        $scope.dataOutbound.payment_type = normalizeEnumValue(paymentValue || $scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type) || 'CREDIT');
        $scope.dataOutbound.collect_type = normalizeEnumValue($scope.dataOutbound.collect_type, 'CASH');
        $scope.dataOutbound.type = deriveOutboundType($scope.dataOutbound.payment_type, $scope.dataOutbound.type);
        $scope.dataOutbound.service = serviceValue || normalizeTextValue($scope.dataOutbound.service) || getFirstOptionValue(distServices, ['ServiceCode']);
        $scope.dataOutbound.uom = uomValue || normalizeTextValue($scope.dataOutbound.uom) || getFirstOptionValue(uomList, ['UOMCode']);
        $scope.dataOutbound.packing = packingValue || normalizeTextValue($scope.dataOutbound.packing) || getFirstOptionValue(packingList, ['PackingName']);

        if (['CASH', 'COLLECT'].indexOf($scope.dataOutbound.collect_type) < 0) {
            $scope.dataOutbound.collect_type = 'CASH';
        }
        if ($scope.item && $scope.item.editIndex < 0 && (!$scope.item.dataItem.uom || canonicalizeOptionValue($scope.item.dataItem.uom) === canonicalizeOptionValue($scope.dataOutbound.uom))) {
            $scope.item.dataItem.uom = $scope.dataOutbound.uom || '';
        }
    }

    function applyDefaultSelections() {
        if (!$scope.defaultData) {
            return;
        }
        if (!$scope.isEdit && !$scope.dataOutbound.service && $scope.defaultData.distServices && $scope.defaultData.distServices.length > 0) {
            $scope.dataOutbound.service = $scope.defaultData.distServices[0].ServiceCode;
        }
        if (!$scope.isEdit && !$scope.dataOutbound.uom && $scope.defaultData.uom && $scope.defaultData.uom.length > 0) {
            $scope.dataOutbound.uom = $scope.defaultData.uom[0].UOMCode;
        }
        if (!$scope.isEdit && !$scope.dataOutbound.packing && $scope.defaultData.packing && $scope.defaultData.packing.length > 0) {
            $scope.dataOutbound.packing = $scope.defaultData.packing[0].PackingName;
        }
        if (!$scope.isEdit && !$scope.dataOutbound.payment_type) {
            $scope.dataOutbound.payment_type = 'CREDIT';
        }
        if (!$scope.isEdit && !$scope.dataOutbound.type) {
            $scope.dataOutbound.type = deriveOutboundType($scope.dataOutbound.payment_type);
        }
        reconcileOutboundSelections();
    }

    function getCurrentAwb() {
        return normalizeAwbValue($scope.dataOutbound.awb || $scope.originalAwb || ($scope.currentAwbStatus && $scope.currentAwbStatus.awb));
    }

    function recalculateCharges() {
        var shipment = roundCurrencyValue($scope.dataOutbound.charge_shipment);
        var packing = roundCurrencyValue($scope.dataOutbound.charge_packing);
        var insurance = roundCurrencyValue($scope.dataOutbound.charge_insurance);
        var discount = roundCurrencyValue($scope.dataOutbound.discount);
        var subTotal = shipment + packing + insurance;
        var vat = normalizeNumberValue($scope.dataOutbound.is_ppn) ? roundCurrencyValue(Math.max(subTotal - discount, 0) / 100) : 0;

        $scope.dataOutbound.sub_total = subTotal;
        $scope.dataOutbound.vat = vat;
        $scope.dataOutbound.total = subTotal - discount + vat;
    }

    function hasShipmentChargeLookupInputs() {
        return !!(
            normalizeTextValue($scope.dataOutbound.shipper_code) &&
            normalizeTextValue($scope.dataOutbound.org_code) &&
            normalizeTextValue($scope.dataOutbound.dest_code) &&
            normalizeTextValue($scope.dataOutbound.uom) &&
            normalizeTextValue($scope.dataOutbound.service) &&
            normalizeTextValue($scope.dataOutbound.modtrans) &&
            Math.max(normalizeNumberValue($scope.dataOutbound.weight), normalizeNumberValue($scope.dataOutbound.weight_metrik)) > 0
        );
    }

    function applyAutoShipmentCharge(result) {
        if (!result || !result.found || $scope.isChargeShipmentManual) {
            return;
        }
        $scope.dataOutbound.charge_shipment = roundCurrencyValue(result.charge_shipment);
        recalculateCharges();
    }

    function lookupShipmentCharge() {
        var query;

        if ($scope.suspendShipmentChargeLookup || !hasShipmentChargeLookupInputs()) {
            return;
        }

        query = [
            'shipper_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.shipper_code)),
            'org_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.org_code)),
            'dest_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.dest_code)),
            'uom=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.uom)),
            'service=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.service)),
            'modtrans=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.modtrans)),
            'weight=' + encodeURIComponent(normalizeNumberValue($scope.dataOutbound.weight)),
            'weight_metrik=' + encodeURIComponent(normalizeNumberValue($scope.dataOutbound.weight_metrik))
        ].join('&');

        urlServices.ambilData('api/outbound/charge-preview?' + query, {}, function (e, o) {
            if (e || !o) {
                return;
            }
            applyAutoShipmentCharge(o);
        });
    }

    function scheduleShipmentChargeLookup() {
        if (shipmentChargeLookupTimer) {
            window.clearTimeout(shipmentChargeLookupTimer);
        }
        shipmentChargeLookupTimer = window.setTimeout(function () {
            shipmentChargeLookupTimer = null;
            lookupShipmentCharge();
        }, 200);
    }

    function normalizeDeleteAuthorization(defaultData) {
        return !!(defaultData && defaultData.canDeleteOutbound);
    }

    function setOutboundData(data) {
        $scope.dataOutbound = angular.extend({}, data || {});
    }

    function applyValueToElement(element, value) {
        var normalizedValue;
        var hasMatchingOption;

        if (!element) {
            return 0;
        }

        if (String(element.tagName || '').toUpperCase() === 'SELECT') {
            normalizedValue = value === undefined || value === null ? '' : String(value);
            hasMatchingOption = normalizedValue === '' || Array.prototype.some.call(element.options || [], function (option) {
                return String(option.value || '') === normalizedValue;
            });

            if (!hasMatchingOption) {
                return 0;
            }
        }

        element.value = value === undefined || value === null ? '' : value;
        element.dispatchEvent(new Event('input', { bubbles: true }));
        element.dispatchEvent(new Event('change', { bubbles: true }));
        return 1;
    }

    function syncControlValue(modelName, value, elementId) {
        var elements = document.querySelectorAll('[ng-model="' + modelName + '"]');
        var touched = 0;

        angular.forEach(elements, function (element) {
            touched += applyValueToElement(element, value);
        });

        if (elementId) {
            touched += applyValueToElement(document.getElementById(elementId), value);
        }

        return touched;
    }

    function runOutboundDomSync() {
        syncControlValue('dataOutbound.awb', $scope.dataOutbound.awb, 'awb');
        syncControlValue('dataOutbound.type', $scope.dataOutbound.type);
        syncControlValue('dataOutbound.po', $scope.dataOutbound.po, 'refno');
        syncControlValue('dataOutbound.pu_date', $scope.dataOutbound.pu_date ? moment($scope.dataOutbound.pu_date).format('MM/DD/YYYY HH:mm') : '', 'pickup_date');
        syncControlValue('dataOutbound.agen', $scope.dataOutbound.agen, 'agen');
        syncControlValue('dataOutbound.pu_code', $scope.dataOutbound.pu_code, 'pickup_id');
        syncControlValue('dataOutbound.org_code', $scope.dataOutbound.org_code);
        syncControlValue('dataOutbound.org_name', $scope.dataOutbound.org_name);
        syncControlValue('dataOutbound.dest_code', $scope.dataOutbound.dest_code);
        syncControlValue('dataOutbound.dest_name', $scope.dataOutbound.dest_name);
        syncControlValue('dataOutbound.service', $scope.dataOutbound.service);
        syncControlValue('dataOutbound.shipper_code', $scope.dataOutbound.shipper_code, 'pengirim_id');
        syncControlValue('dataOutbound.shipper_name', $scope.dataOutbound.shipper_name, 'pengirim_nama');
        syncControlValue('dataOutbound.shipper_address', $scope.dataOutbound.shipper_address, 'pengirim_alamat');
        syncControlValue('dataOutbound.shipper_contact', $scope.dataOutbound.shipper_contact, 'pengirim_pic');
        syncControlValue('dataOutbound.shipper_phone', $scope.dataOutbound.shipper_phone, 'pengirim_telp');
        syncControlValue('dataOutbound.shipper_fax', $scope.dataOutbound.shipper_fax, 'pengirim_fax');
        syncControlValue('dataOutbound.shipper_inst', $scope.dataOutbound.shipper_inst, 'shipper_instruction');
        syncControlValue('dataOutbound.severity', $scope.dataOutbound.severity, 'severity');
        syncControlValue('dataOutbound.consign_name', $scope.dataOutbound.consign_name, 'penerima_nama');
        syncControlValue('dataOutbound.consign_address', $scope.dataOutbound.consign_address, 'penerima_alamat');
        syncControlValue('dataOutbound.consign_phone', $scope.dataOutbound.consign_phone, 'penerima_telp');
        syncControlValue('dataOutbound.consign_fax', $scope.dataOutbound.consign_fax, 'penerima_fax');
        syncControlValue('dataOutbound.consign_postcode', $scope.dataOutbound.consign_postcode, 'kode_post');
        syncControlValue('dataOutbound.reffno3', $scope.dataOutbound.reffno3, 'reffno3');
        syncControlValue('dataOutbound.consign_attn', $scope.dataOutbound.consign_attn, 'attention_to');
        syncControlValue('dataOutbound.isi', $scope.dataOutbound.isi, 'penerima_keterangan');
        syncControlValue('dataOutbound.modtrans', $scope.dataOutbound.modtrans);
        syncControlValue('dataOutbound.weight', $scope.dataOutbound.weight, 'berat_id');
        syncControlValue('dataOutbound.uom', $scope.dataOutbound.uom);
        syncControlValue('dataOutbound.collie', $scope.dataOutbound.collie, 'qty_id');
        syncControlValue('dataOutbound.weight_metrik', $scope.dataOutbound.weight_metrik, 'berat_metrikid');
        syncControlValue('dataOutbound.packing', $scope.dataOutbound.packing);
        syncControlValue('dataOutbound.paket', $scope.dataOutbound.paket);
        syncControlValue('dataOutbound.payment_type', $scope.dataOutbound.payment_type);
        syncControlValue('dataOutbound.collect_type', $scope.dataOutbound.collect_type);
        syncControlValue('dataOutbound.charge_shipment', $scope.dataOutbound.charge_shipment);
        syncControlValue('dataOutbound.charge_packing', $scope.dataOutbound.charge_packing);
        syncControlValue('dataOutbound.charge_insurance', $scope.dataOutbound.charge_insurance);
        syncControlValue('dataOutbound.sub_total', $scope.dataOutbound.sub_total);
        syncControlValue('dataOutbound.discount', $scope.dataOutbound.discount);
        syncControlValue('dataOutbound.vat', $scope.dataOutbound.vat);
        syncControlValue('dataOutbound.total', $scope.dataOutbound.total);
        syncControlValue('dataOutbound.awb_date', $scope.dataOutbound.awb_date ? moment($scope.dataOutbound.awb_date).format('MM/DD/YYYY HH:mm') : '', 'tglshipment');
    }

    function syncOutboundFormFields() {
        [0, 100, 300].forEach(function (delay) {
            window.setTimeout(function () {
                runOutboundDomSync();
            }, delay);
        });
    }

    function mapOutboundMaster(master) {
        return {
            awb: master.AWB || master.awb || '',
            awb_date: (master.AWB_Date || master.awb_date) ? new Date(master.AWB_Date || master.awb_date) : moment()._d,
            pu_date: (master.PU_Date || master.pu_date || master.PU_Time || master.pu_time) ? new Date(master.PU_Date || master.pu_date || master.PU_Time || master.pu_time) : ((master.AWB_Date || master.awb_date) ? new Date(master.AWB_Date || master.awb_date) : moment()._d),
            type: deriveOutboundType(master.Payment || master.payment, master.Type || master.type),
            po: master.PO || master.po || '',
            org_code: master.Org_Code || master.org_code || 'JKT',
            org_name: master.Org_Name || master.org_name || 'JAKARTA',
            org_host_code: master.Org_Host_Code || master.org_host_code || master.Org_Code || master.org_code || 'JKT',
            org_host_name: master.Org_Host_Name || master.org_host_name || master.Org_Name || master.org_name || 'JAKARTA',
            dest_code: master.Dest_Code || master.dest_code || '',
            dest_name: master.Dest_Name || master.dest_name || '',
            dest_host_code: master.Dest_Host_Code || master.dest_host_code || '',
            dest_host_name: master.Dest_Host_Name || master.dest_host_name || '',
            agen: master.Agen || master.agen || '',
            pu_code: master.PU_Code || master.pu_code || '',
            shipper_code: master.Shipper_Code || master.shipper_code || '',
            shipper_name: master.Shipper_Name || master.shipper_name || '',
            shipper_address: master.Shipper_Address || master.shipper_address || '',
            shipper_phone: master.Shipper_Phone || master.shipper_phone || '',
            shipper_fax: master.Shipper_Fax || master.shipper_fax || '',
            shipper_contact: master.Shipper_Contact || master.shipper_contact || '',
            shipper_inst: master.Shipper_Inst || master.shipper_inst || '',
            consign_name: master.Consign_Name || master.consign_name || '',
            consign_address: master.Consign_Address || master.consign_address || '',
            consign_phone: master.Consign_Phone || master.consign_phone || '',
            consign_fax: master.Consign_Fax || master.consign_fax || '',
            consign_postcode: master.Consign_PostCode || master.consign_postcode || '',
            reffno3: master.ReffNo3 || master.reffno3 || '',
            consign_attn: master.Consign_Attn || master.consign_attn || '',
            modtrans: master.ModTrans || master.modtrans || 'AIR',
            service: normalizeTextValue(master.Service || master.service),
            weight: normalizeNumberValue(master.Weight || master.weight),
            collie: normalizeNumberValue(master.Collie || master.collie),
            uom: normalizeTextValue(master.UOM || master.uom),
            packing: normalizeTextValue(master.Packing || master.packing),
            paket: normalizeEnumValue(master.Paket || master.paket || 'P'),
            severity: normalizeEnumValue(master.Severity || master.severity || 'NORMAL'),
            weight_metrik: roundMetricValue(master.Weight_Metrik || master.weight_metrik || master.Volume || master.volume),
            isi: master.Isi || master.isi || '',
            payment_type: normalizeEnumValue(master.Payment || master.payment || derivePaymentType(master.Type || master.type) || 'CREDIT'),
            collect_type: normalizeEnumValue(master.CollectCash || master.collect_cash || 'CASH'),
            shipment_cat: master.Shipment_Cat || master.shipment_cat || 'DOMESTICS',
            shipment_tipe: master.Shipment_Tipe || master.shipment_tipe || 'OUTBOUND',
            insurance: (master.IsInsurance || master.is_insurance) ? 1 : 0,
            is_ppn: (master.ISPPN || master.is_ppn) ? 1 : 0,
            l: normalizeNumberValue(master.L || master.l),
            w: normalizeNumberValue(master.W || master.w),
            h: normalizeNumberValue(master.H || master.h),
            charge_shipment: roundCurrencyValue(master.Charge_Shipment || master.charge_shipment),
            charge_packing: roundCurrencyValue(master.Charge_packing || master.charge_packing),
            charge_insurance: roundCurrencyValue(master.Charge_Insurance || master.charge_insurance),
            sub_total: roundCurrencyValue(master.SubTotal || master.sub_total),
            discount: roundCurrencyValue(master.Discount || master.discount),
            vat: roundCurrencyValue(master.VAT || master.vat),
            total: roundCurrencyValue(master.Total || master.total),
            isvendor: (master.IsVendor || master.isvendor) ? 1 : 0,
            vendorname: master.VendorName || master.vendorname || ''
        };
    }

    function hasMasterLikeFields(candidate) {
        return !!(candidate && typeof candidate === 'object' && (
            candidate.AWB || candidate.awb || candidate.Shipper_Name || candidate.shipper_name ||
            candidate.Consign_Name || candidate.consign_name || candidate.Dest_Name || candidate.dest_name
        ));
    }

    function hasDetailLikeFields(candidate) {
        return !!(candidate && typeof candidate === 'object' && (
            candidate.ItemCode || candidate.item_code || candidate.Description || candidate.desc || candidate.SN || candidate.sn
        ));
    }

    function hasVolumeLikeFields(candidate) {
        return !!(candidate && typeof candidate === 'object' && (
            candidate.Weight_Metric || candidate.weight_metric || candidate.weightMetric || candidate.NoOfCollie || candidate.noOfCollie || candidate.P || candidate.p
        ));
    }

    function findNestedMatch(source, matcher, depth, visited) {
        var keys;
        var index;
        var result;

        if (!source || depth > 5) {
            return null;
        }
        if (typeof source !== 'object') {
            return null;
        }
        if (visited.indexOf(source) >= 0) {
            return null;
        }
        visited.push(source);

        if (matcher(source)) {
            return source;
        }

        if (angular.isArray(source)) {
            for (index = 0; index < source.length; index += 1) {
                result = findNestedMatch(source[index], matcher, depth + 1, visited);
                if (result) {
                    return result;
                }
            }
            return null;
        }

        keys = Object.keys(source);
        for (index = 0; index < keys.length; index += 1) {
            result = findNestedMatch(source[keys[index]], matcher, depth + 1, visited);
            if (result) {
                return result;
            }
        }

        return null;
    }

    function findNestedArray(source, matcher, depth, visited) {
        var keys;
        var index;
        var value;
        var result;

        if (!source || depth > 5) {
            return null;
        }
        if (typeof source !== 'object') {
            return null;
        }
        if (visited.indexOf(source) >= 0) {
            return null;
        }
        visited.push(source);

        if (angular.isArray(source) && source.length > 0 && matcher(source[0])) {
            return source;
        }

        if (angular.isArray(source)) {
            for (index = 0; index < source.length; index += 1) {
                result = findNestedArray(source[index], matcher, depth + 1, visited);
                if (result) {
                    return result;
                }
            }
            return null;
        }

        keys = Object.keys(source);
        for (index = 0; index < keys.length; index += 1) {
            value = source[keys[index]];
            if (angular.isArray(value) && value.length > 0 && matcher(value[0])) {
                return value;
            }
            result = findNestedArray(value, matcher, depth + 1, visited);
            if (result) {
                return result;
            }
        }

        return null;
    }

    function normalizeMasterDetailResponse(response) {
        var normalizedResponse = response || {};
        var rawMaster = normalizedResponse.master || normalizedResponse.Master || normalizedResponse.header || normalizedResponse.Header || normalizedResponse.data || normalizedResponse.Data || normalizedResponse;
        var directMaster = angular.isArray(rawMaster) ? (rawMaster[0] || {}) : (rawMaster || {});
        var master = hasMasterLikeFields(directMaster) ? directMaster : (findNestedMatch(normalizedResponse, hasMasterLikeFields, 0, []) || {});
        var detail = normalizedResponse.detail || normalizedResponse.Detail || normalizedResponse.details || normalizedResponse.Details || findNestedArray(normalizedResponse, hasDetailLikeFields, 0, []) || [];
        var volume = normalizedResponse.volume || normalizedResponse.Volume || normalizedResponse.volumes || normalizedResponse.Volumes || findNestedArray(normalizedResponse, hasVolumeLikeFields, 0, []) || [];
        if (!angular.isArray(detail)) {
            detail = detail ? [detail] : [];
        }
        if (!angular.isArray(volume)) {
            volume = volume ? [volume] : [];
        }

        return {
            master: master,
            detail: detail,
            volume: volume
        };
    }

    function applyMasterDetailResponse(response, awb) {
        var normalizedResponse = normalizeMasterDetailResponse(response);
        var master = normalizedResponse.master;
        var mappedMaster = mapOutboundMaster(master);
        var detailRows = normalizedResponse.detail;
        var volumeRows = normalizedResponse.volume;

        $scope.isEdit = true;
        $scope.isWeightMetricManual = false;
    $scope.isChargeShipmentManual = true;
        $scope.originalAwb = normalizeAwbValue(awb);
        lastLookupAwb = normalizeAwbValue(mappedMaster.awb || awb);
        setOutboundData(mappedMaster);
        reconcileOutboundSelections();
        if (!$scope.dataOutbound.awb) {
            $scope.dataOutbound.awb = normalizeAwbValue(awb);
        }
        $scope.detailItem = detailRows.map(normalizeDetailItem);
        resequenceDetailItems();
        refreshVolumeRows(volumeRows.map(normalizeVolumeRow));
        $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
        $scope.item.editIndex = -1;
        $scope.isReadOnly = !!Number(master.Manifest || 0);
        $scope.currentAwbStatus = {
            awb: master.AWB || awb,
            isManifest: !!Number(master.Manifest || 0),
            statusCode: master.StatusCode || '',
            statusName: master.StatusName || '',
            manifestNo: master.manifest_no || master.Manifest_No || ''
        };
        recalculateCharges();
        syncOutboundFormFields();
    }

    function buildExistingAwbMessage(status) {
        if (status && status.isManifest) {
            return 'AWB Tersebut Sudah Di Manifest';
        }
        return 'AWB Tersebut Sudah Di Entry';
    }

    function requestGeneratedAwb(callback, silent) {
        var paymentType;
        var typeValue;

        if (!$scope.isEWaybillMode || $scope.isEdit) {
            if (callback) {
                callback();
            }
            return;
        }

        paymentType = normalizeEnumValue($scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type), 'CREDIT');
        typeValue = deriveOutboundType(paymentType, $scope.dataOutbound.type);

        urlServices.ambilData('api/outbound/generate-awb?payment_type=' + encodeURIComponent(paymentType) + '&type=' + encodeURIComponent(typeValue), {}, function (e, o) {
            var generatedAwb;

            if (e) {
                if (!silent) {
                    toaster.pop('error', 'E-Waybill', e.err || e || 'Nomor AWB otomatis gagal dibuat');
                }
                if (callback) {
                    callback(e);
                }
                return;
            }

            generatedAwb = normalizeAwbValue(o && o.awb);
            $scope.isAutoNumber = true;
            $scope.dataOutbound.awb = generatedAwb;
            $scope.originalAwb = null;
            lastLookupAwb = generatedAwb || null;
            syncOutboundFormFields();

            if (callback) {
                callback(null, generatedAwb);
            }
        });
    }

    function buildPayload() {
        recalculateVolumeTotals({ preserveManual: true });
        recalculateCharges();

        return angular.extend({}, $scope.dataOutbound, {
            awb: normalizeAwbValue($scope.dataOutbound.awb),
            original_awb: $scope.originalAwb || normalizeAwbValue($scope.dataOutbound.awb),
            is_edit: $scope.isEdit,
            auto_generate_awb: $scope.isEWaybillMode && !$scope.isEdit ? 1 : 0,
            is_e_waybill: $scope.isEWaybillMode ? 1 : 0,
            charge_shipment_manual: $scope.isChargeShipmentManual ? 1 : 0,
            type: deriveOutboundType($scope.dataOutbound.payment_type, $scope.dataOutbound.type),
            payment_type: normalizeEnumValue($scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type), 'CREDIT'),
            collect_type: normalizeEnumValue($scope.dataOutbound.collect_type, 'CASH'),
            detail: ($scope.detailItem || []).map(function (item, index) {
                var normalized = normalizeDetailItem(item, index);

                if (!normalized.sn) {
                    normalized.sn = String(index + 1);
                }
                return normalized;
            }),
            volume: ($scope.volumeRows || []).map(function (row, index) {
                return normalizeVolumeRow(row, index);
            })
        });
    }

    $scope.item = {
        dataItem: createEmptyItem(1),
        editIndex: -1,
        addItem: function () {
            var nextIndex = $scope.item.editIndex >= 0 ? $scope.item.editIndex : $scope.detailItem.length;
            var normalizedItem = normalizeDetailItem(angular.extend({}, $scope.item.dataItem, {
                sn: $scope.item.dataItem.sn || String(nextIndex + 1),
                uom: $scope.item.dataItem.uom || $scope.dataOutbound.uom || ''
            }), nextIndex);

            if (!normalizedItem.item_code && !normalizedItem.desc) {
                return toaster.pop('error', 'Outbound', 'Item code atau description harus diisi');
            }

            if ($scope.item.editIndex >= 0) {
                $scope.detailItem[$scope.item.editIndex] = normalizedItem;
            } else {
                $scope.detailItem.push(normalizedItem);
            }

            resequenceDetailItems();
            $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
            $scope.item.editIndex = -1;
        },
        editItem: function (index, item) {
            $scope.item.editIndex = index;
            $scope.item.dataItem = normalizeDetailItem(angular.copy(item), index);
        },
        deleteItem: function (index) {
            $scope.detailItem.splice(index, 1);
            resequenceDetailItems();
            if ($scope.item.editIndex === index) {
                $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
                $scope.item.editIndex = -1;
            }
        }
    };

    $scope.onVolumeRowChange = function (index) {
        var row = normalizeVolumeRow($scope.volumeRows[index] || {}, index);

        $scope.isWeightMetricManual = false;
        $scope.isChargeShipmentManual = false;
        row.awb = normalizeAwbValue($scope.dataOutbound.awb);
        row.collie = normalizeNumberValue($scope.dataOutbound.collie) || row.collie || $scope.volumeRows.length;
        row.noOfCollie = row.noOfCollie || (index + 1);
        row.weightMetric = calculateWeightMetric(row);
        $scope.volumeRows[index] = row;
        recalculateVolumeTotals();
        scheduleShipmentChargeLookup();
    };

    $scope.onWeightMetricManualChange = function () {
        $scope.isWeightMetricManual = true;
        $scope.isChargeShipmentManual = false;
        $scope.dataOutbound.weight_metrik = roundMetricValue($scope.dataOutbound.weight_metrik);
        scheduleShipmentChargeLookup();
    };

    $scope.onChargeShipmentManualChange = function () {
        $scope.isChargeShipmentManual = true;
    };

    $scope.showListAgen = function () {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'agenList',
            params: {}
        });
    };

    $scope.showListCustomer = function (isReceiver) {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'customerList',
            params: {
                isReceiver: isReceiver
            }
        });
    };

    $scope.showListCourier = function () {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'courierList',
            params: {}
        });
    };

    $scope.showListKota = function (isFrom) {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'cityList',
            params: {
                isFrom: isFrom
            }
        });
    };

    $scope.$on('pilih-agent', function (event, args) {
        $scope.dataOutbound.agen = args.agen.KodeUser;
    });

    $scope.$on('pilih-courier', function (event, args) {
        $scope.dataOutbound.pu_code = args.CourierCode;
    });

    $scope.$on('pilih-contact', function (event, args) {
        if (args && args.isReceiver) {
            $scope.dataOutbound.consign_name = args.CustomerName;
            $scope.dataOutbound.consign_attn = args.PU_Name;
        } else {
            $scope.dataOutbound.shipper_code = args.CustomerCode;
            $scope.dataOutbound.shipper_name = args.CustomerName;
            $scope.dataOutbound.shipper_address = args.Address;
            $scope.dataOutbound.shipper_contact = args.PU_Name;
            $scope.dataOutbound.shipper_phone = args.Phone;
            $scope.dataOutbound.shipper_fax = args.PU_Fax;
            $scope.dataOutbound.is_ppn = args.ISPPN ? 1 : 0;
            recalculateCharges();
        }
        return true;
    });

    $scope.$on('pilih-kota', function (event, args) {
        if (args && args.isFrom) {
            $scope.dataOutbound.org_host_code = args.city.HostCode;
            $scope.dataOutbound.org_host_name = args.city.HostName;
            $scope.dataOutbound.org_code = args.city.CityCode;
            $scope.dataOutbound.org_name = args.city.CityName;
        } else {
            $scope.dataOutbound.dest_host_code = args.city.HostCode;
            $scope.dataOutbound.dest_host_name = args.city.HostName;
            $scope.dataOutbound.dest_code = args.city.CityCode;
            $scope.dataOutbound.dest_name = args.city.CityName;
        }
        return true;
    });

    $scope.getData = function () {
        urlServices.ambilData('/outbound-entry-defaultdata', {}, function (e, o) {
            if (e) {
                return toaster.pop('error', 'Outbound', 'Default data tidak bisa dimuat');
            }
            $scope.defaultData = o;
            $scope.deleteAuthorized = normalizeDeleteAuthorization(o);
            if (o && angular.isArray(o.paymentTypes) && o.paymentTypes.length > 0) {
                $scope.paymentOptions = o.paymentTypes;
            }
            applyDefaultSelections();
            syncOutboundFormFields();
            if ($scope.item.editIndex < 0 && !$scope.item.dataItem.uom) {
                $scope.item.dataItem.uom = $scope.dataOutbound.uom || '';
            }
            scheduleShipmentChargeLookup();
            if ($scope.isEWaybillMode && !$scope.isEdit && !$scope.dataOutbound.awb) {
                requestGeneratedAwb(null, false);
            }
        });
    };

    $scope.addOutbound = function () {
        $scope.isReadOnly = false;
        $scope.isEdit = false;
        $scope.isAutoNumber = $scope.isEWaybillMode;
        $scope.isWeightMetricManual = false;
        $scope.isChargeShipmentManual = false;
        $scope.suspendShipmentChargeLookup = true;
        $scope.originalAwb = null;
        $scope.currentAwbStatus = null;
        lastLookupAwb = null;
        setOutboundData({
            awb_date: moment()._d,
            pu_date: moment()._d,
            org_code: 'JKT',
            org_name: 'JAKARTA',
            org_host_code: 'JKT',
            org_host_name: 'JAKARTA',
            modtrans: 'AIR',
            type: 'CREDIT SALES',
            shipper_inst: '',
            consign_attn: '',
            isi: '',
            severity: 'NORMAL',
            paket: 'P',
            payment_type: 'CREDIT',
            collect_type: 'CASH',
            shipment_cat: 'DOMESTICS',
            shipment_tipe: 'OUTBOUND',
            is_ppn: 0,
            collie: 1,
            l: 0,
            w: 0,
            h: 0,
            charge_shipment: 0,
            charge_packing: 0,
            charge_insurance: 0,
            discount: 0,
            vat: 0,
            sub_total: 0,
            total: 0,
            weight_metrik: 0
        });
        $scope.detailItem = [];
        $scope.item.dataItem = createEmptyItem(1);
        $scope.item.editIndex = -1;
        applyDefaultSelections();
        refreshVolumeRows([], { resetManual: true });
        recalculateCharges();
        syncOutboundFormFields();
        $scope.suspendShipmentChargeLookup = false;
        scheduleShipmentChargeLookup();
        if ($scope.isEWaybillMode && $scope.defaultData) {
            requestGeneratedAwb(null, true);
        }
    };

    $scope.editOutbound = function (awb, options) {
        options = options || {};
        if (!awb) {
            if (options.onComplete) {
                options.onComplete();
            }
            return;
        }
        $scope.loadingData = true;
        urlServices.ambilData('/outbound-entry-data/' + encodeURIComponent(awb), {}, function (e, o) {
            $scope.loadingData = false;
            if (e) {
                if (options.onComplete) {
                    options.onComplete();
                }
                if (!options.silent) {
                    return toaster.pop('error', 'Outbound', e.err || e || 'Data outbound tidak ditemukan');
                }
                return;
            }
            $scope.$evalAsync(function () {
                applyMasterDetailResponse(o, awb);
                if (options.showExistingMessage) {
                    toaster.pop('error', 'Outbound', buildExistingAwbMessage(options.status || $scope.currentAwbStatus));
                }
                if (options.onComplete) {
                    options.onComplete();
                }
            });
        });
    };

    $scope.checkExistingAwb = function () {
        var awb = normalizeAwbValue($scope.dataOutbound.awb);

        $scope.dataOutbound.awb = awb;
        if (!awb || awb.length < 7 || $scope.isAutoNumber || $scope.isEdit || $scope.checkingAwb) {
            return;
        }
        if (lastLookupAwb === awb) {
            return;
        }

        lastLookupAwb = awb;
        $scope.checkingAwb = true;
        $scope.editOutbound(awb, {
            showExistingMessage: true,
            silent: true,
            onComplete: function () {
                $scope.checkingAwb = false;
            }
        });
    };

    $scope.handleAwbKeyDown = function (event) {
        var keyCode = event ? (event.which || event.keyCode) : 0;
        if (keyCode === 13) {
            event.preventDefault();
            $scope.checkExistingAwb();
        }
    };

    $scope.handleAwbKeyUp = function (event) {
        var keyCode = event ? (event.which || event.keyCode) : 0;
        if (keyCode === 13) {
            event.preventDefault();
            $scope.checkExistingAwb();
        }
    };

    $scope.handleFormKeyDown = function (event) {
        var keyCode = event ? (event.which || event.keyCode) : 0;
        var target = event ? (event.target || event.srcElement || {}) : {};
        var tagName = String(target.tagName || '').toUpperCase();
        var inputType = String(target.type || '').toLowerCase();

        if (keyCode !== 13) {
            return;
        }
        if ((target.id || '') === 'awb' || tagName === 'TEXTAREA' || inputType === 'button' || inputType === 'submit') {
            return;
        }
        event.preventDefault();
    };

    $scope.cancelOutbound = function () {
        lastLookupAwb = null;
        $scope.addOutbound();
    };

    $scope.printOutbound = function () {
        var awb = getCurrentAwb();

        if (!awb) {
            return toaster.pop('warning', 'Outbound', 'No AWB tidak boleh kosong');
        }
        window.open('/outbound-print?awb=' + encodeURIComponent(awb), '_blank');
    };

    $scope.deleteOutbound = function () {
        var awb = getCurrentAwb();

        if (!awb) {
            return toaster.pop('warning', 'Outbound', 'No AWB tidak boleh kosong');
        }
        if (!$scope.deleteAuthorized) {
            return toaster.pop('warning', 'Outbound', 'Anda tidak memiliki otoritas hapus outbound');
        }
        if ($scope.isReadOnly || ($scope.currentAwbStatus && $scope.currentAwbStatus.isManifest)) {
            return toaster.pop('warning', 'Outbound', 'AWB ini sudah di manifest dan tidak bisa dihapus');
        }

        modalFactory.open('md', 'modal.delete-awb-reason.html', 'modalDeleteAwbReasonCtrl', {
            title: 'Alasan Hapus Outbound',
            entryLabel: 'Outbound',
            awb: awb
        }).result.then(function (payload) {
            if (!payload || !payload.reason) {
                return;
            }

            $scope.saving = true;
            urlServices.hapusData('api/outbound/' + encodeURIComponent(awb), {
                reason: payload.reason
            }, function (e) {
                $scope.saving = false;
                if (e) {
                    return toaster.pop('error', 'Outbound', e.err || e || 'Data outbound gagal dihapus');
                }

                toaster.pop('success', 'Outbound', awb + ' berhasil dihapus');
                $scope.cancelOutbound();
            });
        }, function () {});
    };

    $scope.saveOutbound = function () {
        var payload;
        var requestMethod;
        var requestUrl;

        if ($scope.saving || $scope.loadingData) {
            return;
        }
        if ($scope.isReadOnly) {
            return toaster.pop('warning', 'Outbound', 'AWB ini sudah di manifest dan tidak bisa diubah');
        }
        if ($scope.isAutoNumber && !$scope.isEdit && !$scope.isEWaybillMode) {
            return toaster.pop('warning', 'Outbound', 'Auto number belum diaktifkan di web');
        }
        if ($scope.isEWaybillMode && !$scope.isEdit && !$scope.dataOutbound.awb) {
            return requestGeneratedAwb(function (generateErr) {
                if (!generateErr) {
                    $scope.saveOutbound();
                }
            }, false);
        }
        if (!$scope.dataOutbound.awb) {
            return toaster.pop('error', 'Outbound', 'No AWB tidak boleh kosong');
        }
        if (!$scope.dataOutbound.org_code || !$scope.dataOutbound.dest_code) {
            return toaster.pop('error', 'Outbound', 'Origin dan destination harus diisi');
        }
        if (!$scope.dataOutbound.shipper_code) {
            return toaster.pop('error', 'Outbound', 'Customer harus dipilih');
        }

        payload = buildPayload();
        requestMethod = $scope.isEdit ? urlServices.updateData : urlServices.simpanData;
        requestUrl = 'api/outbound' + ($scope.isEdit ? '?isedit=true' : '');
        $scope.saving = true;
        requestMethod(requestUrl, payload, function (e, o) {
            $scope.saving = false;
            if (e) {
                return toaster.pop('error', 'Outbound', e.err || e || 'Data outbound gagal disimpan');
            }
            $scope.isEdit = true;
            $scope.originalAwb = o && o.awb ? o.awb : payload.awb;
            lastLookupAwb = $scope.originalAwb;
            $scope.dataOutbound.awb = $scope.originalAwb;
            refreshVolumeRows($scope.volumeRows, { preserveManual: true });
            return toaster.pop('success', 'Outbound', $scope.originalAwb + ' berhasil disimpan');
        });
    };

    $scope.simpanOutbound = $scope.saveOutbound;

    var initialAwb = normalizeAwbValue(urlServices.getUrlParameter('awb') || urlServices.getUrlParameter('cn'));

    if (initialAwb) {
        $scope.editOutbound(initialAwb);
    } else {
        $scope.addOutbound();
    }

    $scope.$watchGroup([
        'dataOutbound.charge_shipment',
        'dataOutbound.charge_packing',
        'dataOutbound.charge_insurance',
        'dataOutbound.discount',
        'dataOutbound.is_ppn'
    ], function () {
        recalculateCharges();
    });

    $scope.$watchGroup([
        'dataOutbound.collie',
        'dataOutbound.l',
        'dataOutbound.w',
        'dataOutbound.h',
        'dataOutbound.modtrans',
        'dataOutbound.awb'
    ], function () {
        refreshVolumeRows(null, { resetManual: true });
    });

    $scope.$watch('dataOutbound.uom', function (value, oldValue) {
        if (!$scope.item || $scope.item.editIndex >= 0) {
            return;
        }
        if (!$scope.item.dataItem.uom || canonicalizeOptionValue($scope.item.dataItem.uom) === canonicalizeOptionValue(oldValue)) {
            $scope.item.dataItem.uom = normalizeTextValue(value);
        }
    });

    $scope.$watch('dataOutbound.awb', function (value) {
        var awb = normalizeAwbValue(value);

        if (awb !== value) {
            $scope.dataOutbound.awb = awb;
            return;
        }
        if (!awb) {
            lastLookupAwb = null;
            return;
        }
        if ($scope.isEdit || $scope.isAutoNumber || awb.length < 7) {
            return;
        }
        $scope.checkExistingAwb();
    });

    $scope.$watchGroup([
        'dataOutbound.shipper_code',
        'dataOutbound.org_code',
        'dataOutbound.dest_code',
        'dataOutbound.uom',
        'dataOutbound.service',
        'dataOutbound.modtrans',
        'dataOutbound.weight',
        'dataOutbound.weight_metrik'
    ], function (newValues, oldValues) {
        if ($scope.suspendShipmentChargeLookup) {
            return;
        }
        if (!oldValues || oldValues.length === 0) {
            return;
        }
        if (angular.equals(newValues, oldValues)) {
            return;
        }
        $scope.isChargeShipmentManual = false;
        scheduleShipmentChargeLookup();
    });

    $scope.getData();
});
